import {useEffect, useState} from "react";
import {classInterface} from "./classes";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {
    ThinChevronRight,
    ThinClassIcon,
    ThinCloseIcon,
    ThinnerPeopleIcon
} from "../../../components/icons/material-icons";
import {GradeToString} from "../students/list";
import {CurrencyFormat} from "../../../components/techaran/money";

export const SelectClassModal = (props: { active: boolean, closeHandler: any, onSelected: any }) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as classInterface[]);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/class/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: classInterface[] | null,
                write: boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
                ShowConnectionFailed('fa');
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            fetchList();
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>انتخاب کلاس</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        loaded ?
                            <div className="add-student">
                                <label style={{marginBottom:20}}>لطفا یک کلاس را انتخاب کنید:</label>
                                <button className="normal-list-tile"
                                        onClick={() => {
                                            props.onSelected(0,'');
                                            props.closeHandler();
                                        }}>
                                    <div>
                                        <i><ThinnerPeopleIcon/></i>
                                        <div>
                                            <b>همه کلاس‌ها</b>
                                        </div>
                                    </div>
                                    <ThinChevronRight/>
                                </button>
                                <hr/>
                                {
                                    list.map((c, i) =>
                                        <button key={"k3kf89d_38" + i}
                                                className="normal-list-tile"
                                                onClick={() => {
                                                    props.onSelected(c.id,c.title);
                                                    props.closeHandler();
                                                }}>
                                            <div>
                                                <i><ThinClassIcon/></i>
                                                <div>
                                                    <b>{c.title}</b>
                                                    <span>{GradeToString(c.grade) + ` (${CurrencyFormat(c.students)} دانش آموز)`}</span>
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </button>
                                    )
                                }
                            </div> :
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{padding: '100px 0'}}>
                                <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};